module.exports = __webpack_public_path__ + "media/f05.f51513c3.mp4";